<template>
  <router-view/>
</template>

<script>
import { mapActions } from 'vuex'
import { operateError } from '@/common/errors'

export default {
  created () {
    this.load(this.$route.params.notebookId)
  },
  beforeRouteUpdate  (to, from, next) {
    if (to.params.notebookId !== from.params.notebookId) {
      this.load(to.params.notebookId)
    }
    next()
  },
  methods: {
    ...mapActions('workbench/current', {
      loadNotebook: 'loadNotebook'
    }),
    async load (notebookId) {
      try {
        await this.loadNotebook({ notebookId })
      } catch (e) {
        console.dir(e)
        operateError(e, '加载笔记本')
      }
    }
  }
}
</script>
